/**
 * /t/<code>: the address written on a tag. Opens the item's article page with the item marked, or the piece's
 * page; a tag of another of the person's companies switches there first.
 * docs/superpowers/specs/2026-10-31-mobile-app-part3-scanning-design.md § The tag's address outside the app
 */
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { authApi } from '../../lib/api'
import { rentalApi } from '../../lib/rentalApi'
import { useAuthStore } from '../../store/auth'
import { useT } from '../../i18n'

export default function TagPage() {
  const t = useT()
  const { code = '' } = useParams()
  const navigate = useNavigate()
  const [none, setNone] = useState(false)
  useEffect(() => {
    let gone = false
    setNone(false)
    void (async () => {
      try {
        let hit = await rentalApi.findTag(code)
        if (!('itemId' in hit)) {
          const { activeCompanyId, setActiveCompany } = useAuthStore.getState()
          if (hit.companyId === activeCompanyId) throw new Error('not here')
          // another of the person's companies: switched there, as the company chooser does
          const { accessToken, activeCompanyId: active, membershipId } = (await authApi.switchCompany(hit.companyId)).data.data
          setActiveCompany({ accessToken, activeCompanyId: active, membershipId })
          hit = await rentalApi.findTag(code)
        }
        if (gone) return
        if (!('itemId' in hit)) { setNone(true); return }
        navigate(hit.isPiece ? `/rental/stock/pieces/${hit.itemId}` : `/rental/stock/articles/${hit.articleId}?item=${hit.itemId}`, { replace: true })
      } catch { if (!gone) setNone(true) }
    })()
    return () => { gone = true }
  }, [code])
  return (
    <div className="card" style={{ maxWidth: 520 }}>
      {none ? <p style={{ margin: 0 }}>{t('rental.tag.none')}</p>
        : <p style={{ margin: 0, color: 'var(--fg-3)' }}>{t('rental.tag.looking')}</p>}
    </div>
  )
}
